﻿import DOMPurify from 'dompurify';

//Encodes HTML string to Base64 for safe transport through ALB rules.
export const encodeHtmlContent = (html: string): string => {
    const bytes = new TextEncoder().encode(html);
    const binary = String.fromCharCode(...bytes);
    return btoa(binary);
};

// Decodes Base64-encoded HTML content returned from the API.
export const decodeHtmlContent = (encoded: string): string => {
    try {
        const binary = atob(encoded);
        const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
        return new TextDecoder().decode(bytes);
    } catch {
        return encoded;
    }
};

export const sanitizeHtmlContent = (html: string): string => {
    return DOMPurify.sanitize(html);
};